import React from 'react';
import { Autocomplete, TextField, FormHelperText, Grid2 } from '@mui/material';
import { useGetWbsLevelQuery } from 'store/slices/apis/wbsLevelSlice';
import { useParams } from 'react-router-dom';

const DynamicWbsSelect = ({ index, level, onSelect, value, touched, error, ...props }) => {

    const { projectId } = useParams();

    const { data: wbsLevelRes, isLoading } = useGetWbsLevelQuery({
        projectId,
        ...(level?.parentId ? { parentId: level?.parentId } : {}),
    }, {
        skip: index !== 0 && !level?.parentId,
    });

    return (
        <Grid2 size={{ xs: 12, md: 6 }}>
            <Autocomplete
                {...props}
                options={wbsLevelRes?.data || []}
                getOptionLabel={(option) => option?.name ?? ''}
                loading={isLoading}
                value={wbsLevelRes?.data?.find((opt) => opt.id === value) || null}
                onChange={(_, newValue) => {
                    onSelect(newValue);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={`WBS Level ${index + 1}`}
                        placeholder={`WBS Level ${index + 1}`}
                        name={`steps[${index}].roles`}
                        variant="filled"
                        slotProps={{ inputLabel: { shrink: true } }}
                    />
                )}
            />
            {touched && error && (
                <FormHelperText sx={{ color: 'red' }}>{error}</FormHelperText>
            )}
        </Grid2>
    );
};

export default DynamicWbsSelect;
